import React, { type Ref, forwardRef } from 'react';
import { useFragment, graphql } from 'react-relay';
import type { TabProps } from '@atlassian/jira-navigation-kit-common/src/types.tsx';
import type { HideNavigationItemArgs } from '@atlassian/jira-navigation-kit-hide-item-service-old/src/services/index.tsx';
import TabMenu from '@atlassian/jira-navigation-kit-tab-menu-old/src/ui/index.tsx';
import TabUIOld from '@atlassian/jira-navigation-kit-ui-tab-old/src/ui/index.tsx';
import type { ui_navigationKitTabOld_Tab$key } from '@atlassian/jira-relay/src/__generated__/ui_navigationKitTabOld_Tab.graphql';

type Props = Omit<TabProps, 'name' | 'isDraggable' | 'menu'> & {
	tabFragment: ui_navigationKitTabOld_Tab$key;
	onHideTab?: (args: Pick<HideNavigationItemArgs, 'id' | 'relayId'>) => void;
	onSetAsDefaultCompleted?: () => void;
	canEdit?: boolean;
	beforeItemId: string | null;
	afterItemId: string | null;
	testId?: string;
	/**
	 * @deprecated remove once navigation-kit-ui-tab-old is removed
	 */
	id?: string;
};
const Tab = forwardRef(
	(
		{
			tabFragment,
			onHideTab,
			onSetAsDefaultCompleted,
			beforeItemId,
			afterItemId,
			canEdit,
			id,
			// remove the destructuring of isOpen when cleaning up navigation-kit-ui-tab-old and spread with tabProps instead
			isOpen,
			...tabProps
		}: Props,
		ref: Ref<HTMLElement>,
	) => {
		const tabData = useFragment(
			graphql`
				fragment ui_navigationKitTabOld_Tab on JiraNavigationItem {
					label @required(action: THROW)
					...ui_navigationKitTabMenuOld_TabMenu
				}
			`,
			tabFragment,
		);

		return (
			<TabUIOld
				name={tabData.label}
				isDraggable={canEdit}
				menu={
					<TabMenu
						tabFragment={tabData}
						onHideClick={onHideTab}
						onSetAsDefaultCompleted={onSetAsDefaultCompleted}
						beforeItemId={beforeItemId}
						afterItemId={afterItemId}
						position={tabProps.position}
						canEdit={canEdit}
					/>
				}
				id={id}
				{...tabProps}
				ref={ref}
			/>
		);
	},
);

export default Tab;
